import axios from "axios";

/**
 * Instância Axios SEM autenticação.
 * Use para endpoints que o backend libera publicamente (sem exigir token).
 * Nunca envia Authorization header, nunca tenta renovar token.
 */
const apiPublic = axios.create({
  baseURL:
    process.env.VUE_APP_API_BASE_URL || "https://gex.nerds.cloudns.be/api/",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export default apiPublic;
